export default __webpack_public_path__ + "static/media/pagination.76cd7775.svg";